import React from 'react';
import { FormInputsData } from '../../data/CreateApplicantData';
import { Tabs } from '../../data/ApplicantsData';
import { ViewFormCustom, TabCustom } from '../common';
import { commonFn } from '../../util/commonFn';

export const ViewApplicant = ({ isEdit, isView, match }) => {
  const tabs = {
    ...Tabs,
    list: commonFn.updateLink(Tabs.list, match),
  };

  const formData = { list: FormInputsData, isEdit, isView };

  return (
    <>
      <TabCustom {...tabs} />
      <ViewFormCustom {...formData} />
    </>
  );
};

export default ViewApplicant;